import {useDisplayMobile} from '@/logged/common/composables';
import {defineStore} from 'pinia';
import {useActiveRoute, useNavigationTabs, useMobileNavBar} from './composables';

export const useAsideMenu = defineStore('aside-menu', () => {
    // - Display modes and mobile mode

    const {isDisplayMobile} = useDisplayMobile();
    const {isMobileNavBarOpened, setMobileNavBarOpened, toggleMobileNavBarOpened} = useMobileNavBar();

    // - Tab list

    const {logoNavigationRoute, allNavigationRoutes, cachedNavigationRoutes, filteredNavigationRoutes, hydrateTabs} = useNavigationTabs();

    // - Active tab

    const {currentActiveRoute, pathname} = useActiveRoute();

    return {
        hydrateFromCache: hydrateTabs,
        currentActiveRoute,
        logoNavigationRoute,
        allNavigationRoutes,
        cachedNavigationRoutes,
        filteredNavigationRoutes,
        isDisplayMobile,
        isMobileNavBarOpened,
        setMobileNavBarOpened,
        toggleMobileNavBarOpened,
        pathname,
    };
});
